// extracted by mini-css-extract-plugin
module.exports = {"button":"tooltip_button__nWmwT","tooltip":"tooltip_tooltip__D58C_","tooltip_wrapper":"tooltip_tooltip_wrapper__6Ufv_"};